// extracted by mini-css-extract-plugin
export default {"contentWrapper":"ContentWrapper_contentWrapper__dpqH3","contentTitle":"ContentWrapper_contentTitle__UBAVA"};